export const GET_YOUTUBE_DATA = "GET_YOUTUBE_DATA";
export const GET_REVIEWS = "GET_REVIEWS";
export const GET_BLOGGER = "GET_BLOGGER";
export const POST_COMMENT_BLOG = "POST_COMMENT_BLOG";
export const POST_REVIEW_LIKE = "POST_REVIEW_LIKE";
export const GET_RELATED_REVIEWS = "GET_RELATED_REVIEWS";
export const SET_FILTER = "SET_FILTER";
export const SET_QUALITY = "SET_QUALITY";
export const CLEAR_FILTER = "CLEAR_FILTER";
export const SET_PAGE = "SET_PAGE";
export const REVIEW_SHARE = "REVIEW_SHARE";
export const SET_RATE = "SET_RATE";
export const SET_CATEGORY = "SET_CATEGORY";
export const SET_SORT = "SET_SORT";